import React from 'react'
import {MOTIFS} from '../data/motifs'
import type {CategoryData} from '../data/types'

interface CategoryHeroProps {
  data: CategoryData
}

const CategoryHero: React.FC<CategoryHeroProps> = ({data}) => {
  const {theme, headline, intro, stats} = data
  const MotifComponent = MOTIFS[theme.motif]

  const cells: Array<{key: string; stat: typeof stats.companies}> = [
    {key: 'companies', stat: stats.companies},
    {key: 'adoption', stat: stats.adoption},
    {key: 'spend', stat: stats.spend},
    {key: 'yoySpend', stat: stats.yoySpend},
    {key: 'vendors', stat: stats.vendors},
  ]

  return (
    <section className="cat-hero" style={{background: theme.bg, '--accent': theme.accent} as React.CSSProperties}>
      <div className="cat-hero-pattern" />
      <div className="cat-hero-vignette" />
      <div className="cat-hero-watermark" aria-hidden="true">
        {MotifComponent && <MotifComponent />}
      </div>
      <div className="wrap">
        <div className="cat-hero-content">
          <div className="cat-hero-tag">
            <span className="dot" style={{background: theme.accent}} />
            <span>{theme.altLabel}</span>
          </div>
          <h2 className="cat-hero-title">
            {headline[0]} <em>{headline[1]}</em>
          </h2>
          <div className="cat-hero-rule" aria-hidden="true" />
          <p className="cat-hero-intro">{intro}</p>
        </div>
      </div>
      <div className="cat-hero-stats-wrap">
        <div className="wrap">
          <div className="cat-hero-stats">
            {cells.map(({key, stat}) => (
              <div key={key} className="cell">
                <div className="label">{stat.label}</div>
                <div className={`val${stat.tone ? ` ${stat.tone}` : ''}`}>{stat.val}</div>
                {stat.sub && <div className="sub">{stat.sub}</div>}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default CategoryHero
